import { Dropdown } from "../../vendor/immomigsa/mig_core/components/dropdown"
import { Autocomplete, AutocompleteResult } from "../../vendor/immomigsa/mig_core/components/autocomplete"
import { Multiselect } from "../../vendor/immomigsa/mig_core/components/multiselect"
import { Datepicker } from "../../vendor/immomigsa/mig_core/components/datepicker"
import { Listing } from "../../vendor/immomigsa/mig_core/components/listing"
import { Form } from "../../vendor/immomigsa/mig_core/components/forms"
import { Filepicker } from "../../vendor/immomigsa/mig_core/components/filepicker"
import { ready, onNewDOM } from "../../vendor/immomigsa/mig_core/components/utils"

import { Toggle } from "./toggle"
import { Tooltip } from './tooltip';


onNewDOM(function(parent) {

  const ads = parent.querySelectorAll("a.disabled");

  ads.forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
      })
  })

  const dds = parent.querySelectorAll('.dropdown');

  dds.forEach((el) => {
      const dd = new Dropdown(el)
  })


  const dps = parent.querySelectorAll('.datepicker-container');

  dps.forEach((el) => {
      const dp = new Datepicker(el, {
          format: el.getAttribute('data-format') || null,
          includeTime: (el.getAttribute('data-timepicker') || "0") == "1",
      })
  })

  const ls = parent.querySelectorAll('.listing');

  ls.forEach((el) => {
      const l = new Listing(el)
  })

  const mss = parent.querySelectorAll('.multiselect');

  mss.forEach((el) => {
      const ms = new Multiselect(el, {
          previewMaxItems: parseInt(el.getAttribute('data-preview-max-items')) || 6,
      })
  })

  const acs = parent.querySelectorAll('.autocomplete.autocomplete-new');

  acs.forEach((el) => {
      if (el.classList.contains('autocomplete-multiple')) {

          const tpl     = el.querySelector(".autocomplete-multi-template > li");
          const results = el.querySelector(".autocomplete-multi-values");

          const ac = new Autocomplete(el, {
              uri: el.getAttribute('data-autocomplete-url'),
              delay: 100,
              onSelect: (r: AutocompleteResult) => {
                  ac.elSearch.value = "";

                  const v = (tpl.cloneNode(true) as Element);

                  const vInput  = (v.querySelector(".autocomplete-value-input") as HTMLInputElement);
                  const vText   = (v.querySelector(".autocomplete-value-text") as HTMLElement);
                  const vDelete = (v.querySelector(".autocomplete-value-delete") as HTMLElement);

                  vInput.removeAttribute("disabled");
                  vInput.value = r.value;

                  vText.textContent = r.text;

                  vDelete.addEventListener("click", (e) => {
                      v.remove();
                  });

                  results.appendChild(v);
              },
          });

          el.querySelectorAll(".autocomplete-multi-values .autocomplete-multi-value .autocomplete-value-delete").forEach((d) => {
              d.addEventListener("click", (e) => {
                  d.closest(".autocomplete-multi-value").remove();
              });
          })

      } else {
          new Autocomplete(el, {
              uri: el.getAttribute('data-autocomplete-url'),
              strict: el.getAttribute('data-autocomplete-strict') == "1",
              delay: 100,
          });
      }

    })

    const allFields = ['role_season', 'role_team', 'role_club'];
    const rolesToFields = new Map<String, Set<String>>() 
    
    rolesToFields.set("TEAM_CAPTAIN", new Set(["role_season", "role_team"]));
    rolesToFields.set("CLUB_ADMIN", new Set(["role_season", "role_club"]));

    parent.querySelectorAll("#form_role").forEach((el: HTMLElement) => {
        let select = el as HTMLSelectElement;

        function onRoleChange() {
            const show = rolesToFields.get(select.value) || new Set();

            allFields.forEach((f) => {
                const ff = document.getElementById("form_"+f).closest(".form-field")
                if (show.has(f)) {
                    ff.classList.remove("hidden");
                } else {
                    ff.classList.add("hidden");
                }
            })
        }

        onRoleChange();
        el.addEventListener("change", onRoleChange);

    })

    const toggles = parent.querySelectorAll('[data-toggle-hidden]');

    for (let i = 0; i < toggles.length; i++) {

        const targets =parent.querySelectorAll(toggles[i].getAttribute('data-toggle-hidden'))

        new Toggle(toggles[i], targets, 'hidden');
    }

    const ps = parent.querySelectorAll('[data-tooltip]');

    for (let i = 0; i < ps.length; i++) {
        const tooltip = document.getElementById(ps[i].getAttribute('data-tooltip'));

        new Tooltip(ps[i], tooltip);
    }

    const fs = parent.querySelectorAll("form.validate");

    for (let i = 0; i < fs.length; i++) {
        new Form(fs[i]);
    }

    const fps = parent.querySelectorAll('.filepicker-container');

    fps.forEach((el) => {
        const fp = new Filepicker(el)
    })


    const fas = parent.querySelectorAll('button.show-advanced-filters')

    fas.forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();

            const expanded = el.getAttribute('aria-expanded') === 'true';
            const target = document.getElementById(el.getAttribute('aria-controls'));

            el.setAttribute('aria-expanded', String(!expanded));
            if (target) {
                target.hidden = expanded;
            }
        })
    })
});

ready(() => {

    const switches = document.querySelectorAll('[data-theme-switch]');

    const isDark = () => {
        const t = document.documentElement.dataset.theme;
        return t ? t === 'dark' : window.matchMedia('(prefers-color-scheme: dark)').matches;
    };

    const syncSwitches = () => {
        switches.forEach((el) => el.setAttribute('aria-checked', String(isDark())));
    };

    switches.forEach((el) => {
        el.addEventListener('click', () => {
            const theme = isDark() ? 'light' : 'dark';
            document.documentElement.dataset.theme = theme;
            try { localStorage.setItem('theme', theme); } catch (e) {}
            syncSwitches();
        })
    })

    syncSwitches();

    document.querySelector('.nav-tabs ul li.active')?.scrollIntoView({ inline: 'center', block: 'nearest' });

    const fpass = document.getElementById("form_password") as HTMLElement;

    if (fpass) {
        fpass.focus()
    }

    const fp = document.getElementById("form_preset") as HTMLSelectElement;

    if (fp) {

        const fs = document.querySelector(".form-fields.form-fields-custom");

        function checkPresetValue() {
        if (fp.value == "custom") {
            fs.classList.remove("hidden");
        } else {
            fs.classList.add("hidden");
        }
        }
        
        checkPresetValue();
        fp.addEventListener("change", checkPresetValue);
    }

    const lp = document.getElementById("login_prompt");

    if (lp) {
        const ep = document.getElementById("email_prompt");

        let user = lp.querySelector('input[name="username"]') as HTMLInputElement;
        let pass = lp.querySelector('input[name="password"]') as HTMLInputElement;

        let email    = ep?.querySelector('input[name="email"]') as HTMLInputElement;

        let cont = document.getElementById('login-continue')

        if (user) {
            user.focus();
        }

        cont?.addEventListener('click', (e) => {
            e.preventDefault();

            if (user.value) {
                user.closest('.form-field')?.classList.remove('form-field-required-empty');

                document.querySelectorAll('.login-step1').forEach((el) => {
                    el.classList.add('hide');
                    cont.remove()
                })
                document.querySelectorAll('.login-step2').forEach((el) => {
                    el.classList.remove('hide');
                })

                pass.focus();
            } else {
                user.closest('.form-field')?.classList.add('form-field-required-empty');
                user.focus();
            }
        })

        ep?.addEventListener('submit', (e) => {
            if (user.value) {
                email.value = user.value;
            } else {
                e.preventDefault();

                user.closest('.form-field')?.classList.add('form-field-required-empty');
                user.focus();
            }
        });
    }


    const pn  = (<HTMLInputElement>document.getElementById("password_new"));
    const pnc = (<HTMLInputElement>document.getElementById("password_new_copy"));

    type PasswordFeedback = {
        feedback: string,
        errors: {
            tooShort: boolean,
            noSymbol: boolean,
        }
    }

    if (pn) {

    function passwordSafetyFeedbacks(pass: string): Set<string> {
        let feedbacks = new Set<string>();

        if (pass.length < 8) {
        feedbacks.add("toosmall");
        }

        if (pass.match(/^[a-zA-Z]+$/) !== null) {
        feedbacks.add("nosymbol");
        }


        let symbols = [...pass.matchAll(/[^a-zA-Z]/g)];

        if (feedbacks.size == 0) {
        if (pass.length < 14 || symbols.length < 2) {
            feedbacks.add("weak");
        } else {
            feedbacks.add("good");
        }
        }

        return feedbacks;
    };

    pn.addEventListener('keyup', (e) => {
        const feedbacks = passwordSafetyFeedbacks(pn.value);

        const elems = pn.parentNode.querySelectorAll('[data-display-feedback]');

        for (let i = 0; i < elems.length; i++) {
        const elem = elems[i];
        const displayIf = elem.getAttribute("data-display-feedback").split(" ");

        let display = false;
        for (let j = 0; j < displayIf.length; j++) {
            if (feedbacks.has(displayIf[j])) {
            display = true;
            break;
            }
        }

        if (display) {
            elem.classList.remove("hidden");
        } else {
            elem.classList.add("hidden");
        }
        }

    });

    }
        
    if (pn && pnc) {
    function passwordCopyFeedbacks(pass1: string, pass2: string): void {
        let feedbacks = new Set<string>();

        if (pass1.length && pass2.length) {
            if (pass1 != pass2) {
                feedbacks.add("different");
            } else {
                feedbacks.add("same");
            }
        }


        const elems = pnc.parentNode.querySelectorAll('[data-display-feedback]');

        for (let i = 0; i < elems.length; i++) {
        const elem = elems[i];
        const displayIf = elem.getAttribute("data-display-feedback").split(" ");

        let display = false;
        for (let j = 0; j < displayIf.length; j++) {
            if (feedbacks.has(displayIf[j])) {
            display = true;
            break;
            }
        }

        if (display) {
            elem.classList.remove("hidden");
        } else {
            elem.classList.add("hidden");
        }
        }

    };

    pn.addEventListener('keyup', (e) => {
        passwordCopyFeedbacks(pn.value, pnc.value);
    });

    pnc.addEventListener('keyup', (e) => {
        passwordCopyFeedbacks(pn.value, pnc.value);
    });

    }


    const pinput = document.getElementById('file_match_sheet');

    if (pinput) {
        async function resizeImage(file, maxWidth = 1600, maxHeight = 1600, quality = 0.8) {
            const bitmap = await createImageBitmap(file);

            // 2. Calculate new dimensions, preserving aspect ratio
            let { width, height } = bitmap;

            if (width > maxWidth || height > maxHeight) {
                const ratio = Math.min(maxWidth / width, maxHeight / height);
                width = Math.round(width * ratio);
                height = Math.round(height * ratio);
            }

            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(bitmap, 0, 0, width, height);

            return new Promise(resolve => {
                canvas.toBlob(resolve, 'image/jpeg', quality);
            });
        }

        pinput.addEventListener('change', async (e) => {
            const file = e.target?.files[0];

            if (!file) return;

            const resizedBlob = await resizeImage(file);

            console.log('Original size:', file.size, 'bytes');
            console.log('Resized size:', resizedBlob.size, 'bytes');

            // Build a File from the blob (keep original name, swap extension if you like)
            const resizedFile = new File(
                [resizedBlob],
                'match_sheet.jpg',
                { type: 'image/jpeg' }
            );
            // Replace the input's FileList using DataTransfer
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(resizedFile);
            e.target.files = dataTransfer.files;
        });
    }
})